import { render, staticRenderFns } from "./Listadoparciales.vue?vue&type=template&id=4959ea09&scoped=true&"
import script from "./Listadoparciales.vue?vue&type=script&lang=js&"
export * from "./Listadoparciales.vue?vue&type=script&lang=js&"
import style0 from "./Listadoparciales.vue?vue&type=style&index=0&id=4959ea09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959ea09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VCard,VCardTitle,VDataTable,VIcon})
